import { Box, BoxProps, styled } from "@mui/material";
import { JoyrideActivator } from "components/joyride/JoyrideActivator";

interface Props extends BoxProps {}
export function JoyrideOverlayer(props: Props) {
  const { ...rest } = props;
  return (
    <StyledBox {...rest}>
      <JoyrideActivator />
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;

  background-color: transparent;
`;
